/**
 * Config the browser needs. Same keys as the publicRuntimeConfig it replaces, so the services that take it keep working.
 * A type alias, not an interface, so it stays assignable to the services' Record<string, string>.
 */
export type AppConfig = {
  postcodeBaseURL: string
  postcodeFindPath: string
  postcodeRetrievePath: string
  postcodeKey: string
  submissionURL: string
  submissionKey: string
  submittedPageURL: string
  cookieDomain: string
  lookupServiceURL: string
  amplitudeApiKey: string
  closeRedirectUrl: string
}

/**
 * Reads the app config from the server environment, so one image can serve QA and prod.
 * Server only: non-public env vars are undefined in the browser. The values reach the browser through the App props.
 * Missing variables become empty strings, which are falsy like the undefined they replace.
 */
export const getAppConfigFromEnv = (env: NodeJS.ProcessEnv = process.env): AppConfig => ({
  postcodeBaseURL: env.postcodeBaseURL ?? '',
  postcodeFindPath: env.postcodeFindPath ?? '',
  postcodeRetrievePath: env.postcodeRetrievePath ?? '',
  postcodeKey: env.postcodeKey ?? '',
  submissionURL: env.submissionURL ?? '',
  submissionKey: env.submissionKey ?? '',
  submittedPageURL: env.submittedPageURL ?? '',
  cookieDomain: env.cookieDomain ?? '',
  lookupServiceURL: env.lookupServiceURL ?? '',
  amplitudeApiKey: env.amplitudeApiKey ?? '',
  closeRedirectUrl: env.closeRedirectURL ?? ''
})
